<template>
	<div class="mid_three">
		<el-row>
			<el-col :span="8">
				<div class="three_effective_accumulated_temperature nav">
					<img src="../../../assets/home/three/effective_accumulated_temperature.png" alt="" />
					<span class="three_effective_accumulated_temperature_text text">有效积温</span>
				</div>

				<div class="three_effective_accumulated_temperature_date date">
					8月1日-8月20日
				</div>
				<div class="three_effective_accumulated_temperature_value value">
					当前有效值：{{three.validAddTemp}}h
				</div>
			</el-col>
			
			<el-col :span="8">
				<div class="rainfall nav">
					<img src="../../../assets/home/three/rainfall.png" alt="" />
					<span class="rainfall_text text">降雨量</span>
				</div>
				<div class="rainfall_date date">
					8月1日-8月20日
				</div>
				<div class="rainfall_value value">
					当前有效值：{{three.differenceRain}}mm
				</div>
			</el-col>
			
			<el-col :span="8">
				<div class="chilling_requirement nav">
					<img src="../../../assets/home/three/chilling_requirement.png" alt="" />
					<span class="chilling_requirement_text text">需冷量</span>
				</div>

				<div class="chilling_requirement_date date">
					8月1日-8月20日
				</div>
				<div class="chilling_requirement_value value">
					当前有效值：{{three.needClodValue}}h
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script setup>
	import {
		onMounted,
		ref
	} from 'vue';
	import {
		GetEnvAdd
	} from '@/api/api.js';
	
	const three = ref({
	  validAddTemp: 0,
	  differenceRain: 0,
	  needClodValue: 0,
	});
	
	onMounted(()=>{
		GetEnvAdd().then(res => {
			three.value=res.data
		}).catch(err => {
			console.log(err)
		})
	})
</script>

<style lang="scss">
	.mid_three {
		padding-top: 10px;
		height: 80px;
		width: 690px;
		text-align: center;
		line-height: 20px;
		margin: 0 auto;
		background-image: url('../../../assets/home/three/three.png');
	}

	.nav {
		height: 20px;
		position: relative;

		img {
			position: absolute;
			left: 80px;
			// width: 18px;
			height: 20px;
		}

		.text {
			color: #8bfd1d;
			position: absolute;
			left: 102px;
		}

	}

	.value {
		color: white;
		text-align: center;
	}

	.date {
		color: white;
		text-align: center;
	}
</style>